/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarButtons_user = {|
  +isVerifiedTrade: ?boolean;
  +favorites?: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "favoritePages",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "fetchFavorites",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestSourcingButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedAffirm_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchFavorites",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1,
              "type": "Int"
            },
            {
              "kind": "Variable",
              "name": "pages",
              "variableName": "favoritePages",
              "type": "[String]"
            },
            {
              "kind": "Literal",
              "name": "types",
              "value": [
                "SEARCH"
              ],
              "type": "[types]"
            }
          ],
          "concreteType": "favoritesConnection",
          "name": "favorites",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "FollowSearchButton_favoritesConnection",
              "args": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "User"
};

module.exports = fragment;
